import Datatable from "@components/datatable";
import KycReminderDialog from "./components/kyc-reminder-dialog";
import PublishersFilterBar from "./components/publishers-filter-bar";
import usePublishers from "./hooks/use-publishers";
import { getPublishersColumns } from "./misc/columns";

const Publishers = () => {
    const {
        rows, pagination, loading,
        filters, handleFilterChange,
        handlePageChange, handlePerRowsChange, openPublisher, kyc
        // exportCsv
    } = usePublishers();

    return (
        <div className="p-6">
            <div className="flex items-start justify-between">
                <div>
                    <h1 className="text-2xl font-semibold tracking-tight">Publishers</h1>
                    <p className="text-sm text-muted">{pagination.total} publisher(s) across all brands.</p>
                </div>
                {/* <button
                    type="button"
                    onClick={exportCsv}
                    className="inline-flex h-10 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 text-sm font-medium text-gray-700 hover:bg-gray-50">
                    <Download className="h-4 w-4" />
                    Export CSV
                </button> */}
            </div>

            <PublishersFilterBar filters={filters} onFilterChange={handleFilterChange} />

            <div className="mt-4 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
                <Datatable
                    columns={getPublishersColumns(kyc)}
                    data={rows}
                    loading={loading}
                    pagination={{ count: pagination.total, page: pagination.page, limit: pagination.limit }}
                    handlePageChange={handlePageChange}
                    handlePerRowsChange={handlePerRowsChange}
                    onRowClicked={openPublisher}
                    customNoData={<span className="text-sm text-muted">No publishers found.</span>} />
            </div>

            <KycReminderDialog kyc={kyc} />
        </div>
    );
};

export default Publishers;
